import { render, staticRenderFns } from "./CadastroServico.vue?vue&type=template&id=763204aa"
import script from "./CadastroServico.vue?vue&type=script&lang=js"
export * from "./CadastroServico.vue?vue&type=script&lang=js"
import style0 from "./CadastroServico.vue?vue&type=style&index=0&id=763204aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports